var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomShower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 159,
    viewBox: "0 0 136 159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M131 96h-5V22.5c0-6.904-5.596-12.5-12.5-12.5-2.15 0-4.173.543-5.94 1.499l-3.644-3.644A17.418 17.418 0 01113.5 5c9.665 0 17.5 7.835 17.5 17.5V96z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M130.5 95.5v-73c0-9.389-7.611-17-17-17-3.145 0-6.161.855-8.787 2.444l2.941 2.942A12.947 12.947 0 01113.5 9.5c7.18 0 13 5.82 13 13v73h4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M22 149h14l-4 15H22z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M22.5 149.5v14h9.116l3.733-14H22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M115 149h-14l4 15h10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M114.5 149.5v14h-9.116l-3.733-14H114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M132.076 102l-6.68 34c-1.627 8.284-9.662 15-17.946 15h-79c-8.284 0-16.32-6.716-17.947-15l-6.68-34h128.253z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M131.468 102.5H4.432l6.562 33.404c1.581 8.051 9.412 14.596 17.456 14.596h79c8.043 0 15.874-6.545 17.456-14.596l6.562-33.404z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 136,
    height: 8,
    y: 95,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 135,
    height: 7,
    x: 0.5,
    y: 95.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 35,
    height: 43,
    x: 18,
    y: 91,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 34,
    height: 42,
    x: 18.5,
    y: 91.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M18 126h35v12H18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M18.5 126.5h34v11h-34z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M90.54 10.29c4.75-4.915 11.9-6.057 16.75-2.402 4.85 3.654 5.724 10.843 2.308 16.764L90.54 10.291z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M91.3 10.238l18.139 13.668c3-5.665 2.01-12.259-2.45-15.619-4.459-3.36-11.07-2.494-15.689 1.95z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomShower);
export default __webpack_public_path__ + "static/media/RoomShower.868c3f7325900125156ea84c0e81e596.svg";
export { ForwardRef as ReactComponent };